module.exports = __webpack_public_path__ + "static/media/mic-32px.e86ba651.svg";